// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import vuetify from '@/plugins/vuetify';
import store from './store';
import axios from 'axios';
import VueGtm from 'vue-gtm';

axios.defaults.withCredentials = false
axios.defaults.baseURL = process.env.API_URL_1;

axios.interceptors.response.use(undefined, function(error) {
  if (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      store.dispatch("logOut");
      return router.push("/");
    }else{
      return Promise.reject(error);
    }
  }
});

Vue.config.productionTip = false;

Vue.use(VueGtm, {
  id: process.env.GTM_ID,
  vueRouter: router,
  enabled: process.env.GTM_ENABLED,
  debug: process.env.GTM_DEBUG,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  vuetify,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js